// extracted by mini-css-extract-plugin
export default {"tabContentMargin":"task-editor_tabContentMargin__l-m6T"};